import request from '../utils/request'

// 生成佐证回显数据
export const getData = (userId) => {
  return request({
    url: `/evaluationReport/${userId}`,
    method: 'GET',
  })
}

// 生成佐证保存数据
export const saveData = (data) => {
  return request({
    url: '/evaluationReport',
    method: 'POST',
    data
  })
}
// 生成佐证数据
export const downloadReport = (userId) => {
  return request({
    url: `/evaluationReport/generateAndDownWord/${userId}`,
    method: 'GET',
  })
}

// 下载
export const downWord = (id) => {
  return request({
    url: `/minio/${id}`,
    method: 'GET',
    timeout: 1000000,
    responseType: 'blob'
  })
}
